import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AdminAccess, CompanyAccess } from 'src/model/companyAccess.model';
import { User } from 'src/model/user.model';
import { AdminAccessService } from 'src/services/admin-access.service';
import { UserService } from 'src/services/user.service';
import { AccessAction, AccessActionComponent } from '../access-action/access-action.component';
import { Company } from 'src/model/company.model';
import { CompanyService } from 'src/services/company.service';

@Component({
    selector: 'app-admin-access-management',
    templateUrl: './admin-access-management.component.html',
    styleUrl: './admin-access-management.component.scss',
    standalone: false
})

export class AdminAccessManagementComponent implements OnInit {
  protected sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);
  private enums = inject(Enums);
  private userService = inject(UserService);
  private accessService = inject(AdminAccessService);
  private companyService = inject(CompanyService);

  companyAccessList: CompanyAccess[] = [];
  companyList: Company[] = [];
  userList: User[] = [];
  adminAccessList: AdminAccess[] = [];
  adminCompanyList: Record<number, CompanyAccess[]> = {};

  ngOnInit(): void {
    this.refresh();
  }

  async refresh() {
    [this.companyAccessList, this.userList, this.companyList] = await Promise.all([
      this.accessService.getCompaniesAccess(),
      this.userService.getAllUsers({ roleId: [this.enums.ADMIN], isActive: true }),
      this.companyService.getAllCompanies()
    ]);

    this.adminCompanyList = this.sharedService.groupBy(this.companyAccessList, 'Username');

    this.adminAccessList = this.userList.map(u => this.getAdminAccess(u.Username));
    this.adminAccessList.sort((a, b) =>
      a.username.toLowerCase().localeCompare(b.username.toLowerCase())
    );

    this.cdr.detectChanges();
  }

  getAdminAccess(username: string): AdminAccess {
    const companyAccess = this.companyAccessList
      .filter((c) => c.Username == username && c.Priority % 10 == 0)
      .map((c) => c.CompanyId);

    const tempAccess = this.companyAccessList
      .filter((c) => c.Username == username && c.Priority % 10 == 1 && c.Priority !== this.enums.ON_DUTY_PRIORITY)
      .map((c) => c.CompanyId);

    const onDutyAccess = this.companyAccessList
      .filter((c) => c.Username == username && c.Priority === this.enums.ON_DUTY_PRIORITY)
      .map((c) => c.CompanyId);

    return { username: username, companyAccess: companyAccess, companyCount: companyAccess.length, tempAccess: tempAccess, tempAccessCount: tempAccess.length, onDutyAccess: onDutyAccess, onDutyAccessCount: onDutyAccess.length };
  }

  openAddOnDutyAdminModal() {
    const modalRef = this.sharedService.openModal(AccessActionComponent);
    modalRef.componentInstance.action = AccessAction.Duty;
    modalRef.componentInstance.adminAccessList = this.adminAccessList;
  }
}
